export enum UserSignUpSource {
  ParentInvitationPage = 'parent_invitation_signup',
  StaffInvitationPage = 'staff_invitation_signup',
  ChooseRoleModal = 'choose_role_modal',
  DirectorJoinPage = 'director_join_page',
  DirectorNetworkJoinPage = 'director_network_join_page',
  DirectorSignUpModal = 'director_signup_modal',
  JoinPage = 'join_page',
  ParentBookmarkModal = 'parent_bookmark_modal',
  ParentContactModal = 'parent_contact_modal',
  ParentDetailedPricingModal = 'parent_detailed_pricing_modal',
  ParentGatheringModal = 'parent_gathering_modal',
  ParentJoinPage = 'parent_join_page',
  ParentSaveSearchInlineForm = 'parent_save_search_inline_form',
  ParentSearchModal = 'parent_save_search_modal',
  ParentSignUpModal = 'parent_signup_modal',
  ParentTourModal = 'parent_tour_modal',
  ParentEnrollNowModal = 'parent_enroll_now_modal',
  ParentInstantEnrollModal = 'parent_instant_enroll_modal',
  ParentExternalSchoolRequestInfoModal = 'parent_external_school_request_info_modal',
}
